import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { routesList } from "./index";
import Page404 from "../components/views/Page404";

const Routes = () => {
  return (
    <Router>
      <Switch>
        {routesList.map(({ path, component: Component }, index) => (
          <Route key={index} path={path} exact component={Component} />
        ))}
        <Route component={Page404} />
      </Switch>
    </Router>
  );
};

export default Routes;
